import * as ReduInfoDisplay from './ReduInfoDisplay';

export default ReduInfoDisplay.default;
